module.exports = {"id":"219693","name":"Diego Carlos","rating":"79","photo":"./data/images/photos/2/219693.png","club":{"name":"FC Nantes","logo":"./data/images/clubs/FCNantes.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoCarlos0.json
// module id = 1072
// module chunks = 0